export default {
  Inactive: "Inactive",
  Active: "Active",
  Upcoming: "Pending",
  Expired: "Expired",
  RequiresApproval: "Requires Approval",
  Draft: "Draft",
};
